import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop"; // Import the component
import Home from "./pages/Home";
import About from "./pages/About";
import WhySeagull from "./pages/WhySeagull";
import Solutions from "./pages/Solutions";
import ProductsIndustries from "./pages/ProductsIndustries";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop /> {/* Add this line */}
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-seagull" element={<WhySeagull />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/products-industries" element={<ProductsIndustries />} />
            <Route path="/contact" element={<Contact />} />
            // Add to routes
            <Route path="/resources" element={<Resources />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
